var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('strong',[_vm._v(_vm._s(_vm.name))]),_vm._v(" "),(_vm.description)?_c('small',{class:["d-block", { "text-white": _vm.active, "text-muted": !_vm.active }]},[_vm._v("\n    "+_vm._s(_vm.description)+"\n  ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }